export const STEPS_MOBILE_TITLE = 'steps-mobile-title';
